export const eventEmitterRTTI = Symbol.for("eventEmitter");
